import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { ApplicationItemInfo } from "./ApplicationItemInfo";
import { HttpclientService } from "../../../shared";

@Injectable()
export class MasterService {
	constructor() {}

	private currentApplicationItem: ApplicationItemInfo;
	private lstApplicationItems: any;
	private subject = new Subject<any>();
	routeChanged() {
		this.subject.next(true);
	}

	CheckRouteChange(): Observable<any> {
		return this.subject.asObservable();
	}

	setApplicationItemList(applicationItems) {
		this.lstApplicationItems = applicationItems;
	}

	getCurrentApplicationItem(): ApplicationItemInfo {
		return this.currentApplicationItem;
	}

	getCurrentApplicationItemByUrl(url) {
		var key = this.ReplaceAllOccur(url.substring(1), "/", "|").toLowerCase();

		//
		// Ex.
		//  Normal Item Students|Release, (1 Slashes, under a category)
		//  Single Page DashboardVisitor (0 Slash)
		//
		var numSlash: number = 0;
		numSlash = this.CountChar(key, "|");

		//
		// Single Page Item
		//
		if (numSlash == 0) {
			var lstApplicationWithChildren = this.lstApplicationItems.filter((a) => {
				return a.Children.length == 0 && a.IsParent == true;
			});

			for (let applicationItem of lstApplicationWithChildren) {
				if (applicationItem.ApplicationItemKey.toLowerCase() == key.toLowerCase()) {
					this.currentApplicationItem = applicationItem;
					return applicationItem;
				}
			}
		}
		//
		// Nested Items
		// (Ex. Groups/Events/Define Events)
		//
		else if (numSlash > 1) {
			var lstApplicationWithChildren = this.lstApplicationItems.filter((a) => {
				return a.Children.length > 0;
			});

			var lstChildCategoriesWithChildren: any = [];

			for (var z = 0; z < lstApplicationWithChildren.length; z++) {
				var nextParent = lstApplicationWithChildren[z];

				for (var i = 0; i < nextParent.Children.length; i++) {
					var nextChild = nextParent.Children[i];

					if (nextChild.Children.length > 0 && nextChild.RouterLink != "/") {
						lstChildCategoriesWithChildren = [...lstChildCategoriesWithChildren, ...nextChild.Children];
					}
				}
			}

			for (let applicationItem of lstChildCategoriesWithChildren) {
				if (applicationItem.ApplicationItemKey.toLowerCase() == key.toLowerCase()) {
					this.currentApplicationItem = applicationItem;
					return applicationItem;
				}
			}
		}
		//
		// Normal Method
		//
		else {
			var lstApplicationWithChildren = this.lstApplicationItems.filter((a) => {
				return a.Children.length > 0;
			});

			for (let applicationItem of lstApplicationWithChildren) {
				var subSet = applicationItem.Children.filter((a) => {
					return a.ApplicationItemKey.toLowerCase() == key.toLowerCase();
				});

				if (subSet.length > 0) {
					let item = subSet[0];
					this.currentApplicationItem = item;
					return item;
					//.ApplicationItemID;
				}
			}
		}
	}

	getApplicationItemByKey(applicationItemKey) {
		var lstApplicationWithChildren = this.lstApplicationItems.filter((a) => {
			return a.Children.length > 0;
		});

		for (let applicationItem of lstApplicationWithChildren) {
			var subSet = applicationItem.Children.filter((a) => {
				return a.ApplicationItemKey.toLowerCase() == applicationItemKey.toLowerCase();
			});
			if (subSet.length > 0) {
				let item = subSet[0];
				return item;
				//.ApplicationItemID;
			}
		}
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string) {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	CountChar(mainStr: string, stringToFind: string) {
		var ans: number = 0;

		for (var z = 0; z < mainStr.length - stringToFind.length; z++) {
			var next = mainStr.substring(z, z + stringToFind.length);

			if (String(next) == String(stringToFind)) {
				ans++;
			}
		}

		return ans;
	}
}
